<template>
    <div class="table-responsive text-left mt-3">
        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n3 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>
        <table class="table">
            <thead class="bg-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Link-Id</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Paid</th>
                    <th scope="col" class="text-right">Remove</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(links, x) in oldPayLinksArr" :key="x">
                    <td>{{x+1}}.</td>
                    <td>{{links._id}}</td>
                    <td>{{user.currency.toUpperCase()}} {{links.amount | money}}</td>
                    <td>
                        <span v-if="links.paid" class="text-dark-green">Yes</span>
                        <span v-else class="text-danger">No</span>
                    </td>
                    <td class="text-right">
                        <button @click.prevent="deleteOldPayLinkFxn(links._id)" class="btn btn-danger btn-sm">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "OldPayLink",
    props: ['itemId'],
    data() {
        return {
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['deleteOldPayLink']),
        deleteOldPayLinkFxn(theLinkId){
            let linkObj = {
                linkId: theLinkId,
                itemId: this.itemId,
                userId: this.user._id
            }
            this.deleteOldPayLink(linkObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.$emit('emptyPayLink', true)
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.color = "danger"
                this.msg = "Unable to remove payment link at this time, try again later."
            })
        }
    },
    computed: {
        ...mapGetters(['user', 'oldPaymentLinks']),
        oldPayLinksArr() {
            if(this.oldPaymentLinks && this.oldPaymentLinks.length){
                return this.oldPaymentLinks
            }
            return false
        },
    }
}
</script>